import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from './i18n'
import { initializeAnalytics } from './utils/analytics'
import { setupGA4DebugCommands } from './utils/ga4Debug'
import { setupGA4Troubleshoot } from './utils/ga4Troubleshoot'
import { AdConsentManager } from './utils/adConsent'
import './utils/adDebug'
import './utils/adTroubleshoot'
import AdDebugConsole from './utils/adDebugConsole'
import DevEnvironmentChecker from './utils/devEnvironmentCheck'
import './assets/css/main.css'
import './assets/css/responsive.css'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

// 初始化廣告同意（開發環境自動設置）
AdConsentManager.setupDevConsent()

// 安裝插件
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(head)

// 首先掛載應用程式，確保頁面能正常載入
app.mount('#app')

// 在應用掛載後非阻塞地初始化 Analytics
// 使用 setTimeout 確保完全非阻塞
setTimeout(() => {
  try {
    console.log('🔄 開始初始化 Analytics...')
    initializeAnalytics()
  } catch (error) {
    console.warn('⚠️ Analytics 初始化失敗，但不影響網站運行:', error)
  }
}, 100)

// 初始化 GA4 調試工具（非阻塞）
setTimeout(() => {
  try {
    setupGA4DebugCommands()
    setupGA4Troubleshoot()
  } catch (error) {
    console.warn('⚠️ GA4 調試工具初始化失敗:', error)
  }
}, 200)

// 初始化 AdSense 調試工具（僅在開發環境）
if (import.meta.env.DEV) {
  setTimeout(() => {
    try {
      console.log('🔧 初始化 AdSense 調試控制台...')
      AdDebugConsole.getInstance().initializeDebugConsole()
      
      console.log('🔍 初始化開發環境檢查器...')
      DevEnvironmentChecker.getInstance().initializeChecker()
    } catch (error) {
      console.warn('⚠️ 調試工具初始化失敗:', error)
    }
  }, 500)
  
  // 自動執行 GA4 診斷
  setTimeout(async () => {
    try {
      if ((window as any).GA4Debug) {
        console.log('🔍 執行 GA4 自動診斷...')
        await (window as any).GA4Debug.check()
      }
      
      // 自動執行故障排除
      if ((window as any).GA4Troubleshoot) {
        console.log('🔧 執行 GA4 故障排除...')
        await (window as any).GA4Troubleshoot.diagnose()
      }
    } catch (error) {
      console.warn('⚠️ GA4 診斷失敗:', error)
    }
  }, 3000)
} 